import React from 'react';
import { InfoImage, ProductInfoImageContainer } from './styled';
import ScrollWrapper from '../../ScrollWrapper/ScrollWrapper';
import Image from 'next/image';
import { calculatePaddingTop } from '../../CategoryL2Page/utils';

const ProductInfoImages = ({ productId }) => {
  // const images = [
  //     {
  //         image: "https://images.myloapp.in/NestJsUploads/1703576622048-Module_1.webp",
  //         aspectRatio: "17:25",
  //     },
  //     {
  //         image: "https://images.myloapp.in/NestJsUploads/1703576622050-Module_2.webp",
  //         aspectRatio: "7:10",
  //     },
  //     {
  //         image: "https://images.myloapp.in/NestJsUploads/1703576622051-Module_3.webp",
  //         aspectRatio: "117:100",
  //     },
  //     {
  //         image: "https://images.myloapp.in/NestJsUploads/1703576622051-Module_4.webp",
  //         aspectRatio: "159:100",
  //     },
  //     {
  //         image: "https://images.myloapp.in/NestJsUploads/1703576622052-Module_5.webp",
  //         aspectRatio: "107:100",
  //     },
  //     {
  //         image: "https://images.myloapp.in/NestJsUploads/1703577151960-Module_6.webp",
  //         aspectRatio: "103:100",
  //     },
  //     {
  //         image: "https://images.myloapp.in/NestJsUploads/1703577151960-Module_7.webp",
  //         aspectRatio: "107:100",
  //     },
  // ];
  const smkImages = [
    {
      image:
        'https://images.myloapp.in/skuImages/979/APlus/App/EN/Module_1.webp',
      aspectRatio: '240:337',
    },
    {
      image:
        'https://images.myloapp.in/skuImages/979/APlus/App/EN/Module_2.webp',
      aspectRatio: '720:947',
    },
    {
      image:
        'https://images.myloapp.in/skuImages/979/APlus/App/EN/Module_3.webp',
      aspectRatio: '80:71',
    },
    {
      image:
        'https://images.myloapp.in/skuImages/979/APlus/App/EN/Module_4.webp',
      aspectRatio: '240:337',
    },
    {
      image:
        'https://images.myloapp.in/skuImages/979/APlus/App/EN/Module_5.webp',
      aspectRatio: '45:77',
    },
    {
      image:
        'https://images.myloapp.in/skuImages/979/APlus/App/EN/Module_6.webp',
      aspectRatio: '720:809',
    },
    {
      image:
        'https://images.myloapp.in/skuImages/979/APlus/App/EN/Module_7.webp',
      aspectRatio: '720:809',
    },
    {
      image:
        'https://images.myloapp.in/skuImages/979/APlus/App/EN/Module_8.webp',
      aspectRatio: '80:103',
    },
    {
      image:
        'https://images.myloapp.in/skuImages/979/APlus/App/EN/Module_9.webp',
      aspectRatio: '72:85',
    },
    {
      image:
        'https://images.myloapp.in/skuImages/979/APlus/App/EN/Module_10.webp',
      aspectRatio: '6:7',
    },
    {
      image:
        'https://images.myloapp.in/skuImages/979/APlus/App/EN/Module_11.webp',
      aspectRatio: '360:553',
    },
  ];
  const carrierImages = [
    {
      image:
        'https://images.myloapp.in/skuImages/3434/APlus/App/EN/Module_1.webp',
      aspectRatio: '360:509',
    },
    {
      image:
        'https://images.myloapp.in/skuImages/3434/APlus/App/EN/Module_2.webp',
      aspectRatio: '30:41',
    },
    {
      image:
        'https://images.myloapp.in/skuImages/3434/APlus/App/EN/Module_3.webp',
      aspectRatio: '80:87',
    },
    {
      image:
        'https://images.myloapp.in/skuImages/3434/APlus/App/EN/Module_4.webp',
      aspectRatio: '30:23',
    },
    {
      image:
        'https://images.myloapp.in/skuImages/3434/APlus/App/EN/Module_5.webp',
      aspectRatio: '180:143',
    },
    {
      image:
        'https://images.myloapp.in/skuImages/3434/APlus/App/EN/Module_6.webp',
      aspectRatio: '9:13',
    },
    {
      image:
        'https://images.myloapp.in/skuImages/3434/APlus/App/EN/Module_7.webp',
      aspectRatio: '720:1213',
    },
    {
      image:
        'https://images.myloapp.in/skuImages/3434/APlus/App/EN/Module_8.webp',
      aspectRatio: '60:61',
    },
    {
      image:
        'https://images.myloapp.in/skuImages/3434/APlus/App/EN/Module_9.webp',
      aspectRatio: '20:29',
    },
  ];
  const carrierRedImages = [
    {
      image:
        'https://images.myloapp.in/skuImages/3433/APlus/App/EN/slide_1.webp',
      aspectRatio: '360:509',
    },
    {
      image:
        'https://images.myloapp.in/skuImages/3433/APlus/App/EN/slide_2.webp',
      aspectRatio: '30:41',
    },
    {
      image:
        'https://images.myloapp.in/skuImages/3433/APlus/App/EN/slide_3.webp',
      aspectRatio: '80:87',
    },
    {
      image:
        'https://images.myloapp.in/skuImages/3433/APlus/App/EN/slide_4.webp',
      aspectRatio: '30:23',
    },
    {
      image:
        'https://images.myloapp.in/skuImages/3433/APlus/App/EN/slide_5.webp',
      aspectRatio: '180:143',
    },
    {
      image:
        'https://images.myloapp.in/skuImages/3433/APlus/App/EN/slide_6.webp',
      aspectRatio: '9:13',
    },
    {
      image:
        'https://images.myloapp.in/skuImages/3433/APlus/App/EN/slide_7.webp',
      aspectRatio: '720:1213',
    },
    {
      image:
        'https://images.myloapp.in/skuImages/3433/APlus/App/EN/slide_8.webp',
      aspectRatio: '60:61',
    },
    {
      image:
        'https://images.myloapp.in/skuImages/3433/APlus/App/EN/slide_9.webp',
      aspectRatio: '20:29',
    },
  ];
  const dataObj = {
    category: 'impression_section_in_pdp',
    section_name: 'Product Info Images',
    section_id: '',
    deeplink_value: null,
    shape: '',
    card_ids: [],
    sku_id: productId,
  };
  const images =
    productId == 979
      ? smkImages
      : productId == 3434
        ? carrierImages
        : carrierRedImages;
  return (
    <ScrollWrapper data={dataObj} sectionId={'infoImages'} threshold={0.2}>
      <ProductInfoImageContainer>
        {images.map((item, index) => {
          return (
            <InfoImage
              key={'infoImages' + index}
              negativeMargin={index == 3}
              paddingTop={calculatePaddingTop(item.aspectRatio)}
            >
              <Image
                src={item.image}
                alt=""
                loading="lazy"
                quality={90}
                fill
                sizes="33vw"
              />
            </InfoImage>
          );
        })}
      </ProductInfoImageContainer>
    </ScrollWrapper>
  );
};

export default ProductInfoImages;
